import { useEffect, useRef, useState } from "react";
import type { UseIntervalCallback } from "./useInterval";

//const getSecondsRemaining = (expiresMs: number) => {
//    const secondsRemaining = Math.ceil(expiresMs - Date.now()) / 1000;
//    return secondsRemaining;
//}

export class CountdownTimerState {
	private secondsRemaining: number;

	constructor(secondsRemaining: number) {
		this.secondsRemaining = secondsRemaining;
	}

	getSecondsRemaning() {
		return this.secondsRemaining;
	}
}

export const useCountdownTimerState = (
	callback: UseIntervalCallback,
	expiresInSec: number,
) => {
	const savedCallback = useRef<UseIntervalCallback | null>(null);
	const expiresRef = useRef<number>(0);
	const [secondsRemaining, setSecondsRemaining] =
		useState<number>(expiresInSec);
	const secondsRemainingRef = useRef(secondsRemaining);
	useEffect(() => {
		secondsRemainingRef.current = secondsRemaining;
	}, [secondsRemaining]);

	// Remember the latest callback.
	useEffect(() => {
		savedCallback.current = callback;
	}, [callback]);

	// Set up the interval.
	useEffect(() => {
		const tick = () => {
			const nextRemaining = Math.ceil((expiresRef.current - Date.now()) / 1000);
			if (nextRemaining !== secondsRemainingRef.current) {
				setSecondsRemaining(nextRemaining);
			}
			if (
				nextRemaining <= 0 &&
				savedCallback &&
				savedCallback.current &&
				!document.hidden
			) {
				savedCallback.current();
			}
		};
		const id = setInterval(tick, 250);
		return () => clearInterval(id);
	}, []);

	useEffect(() => {
		expiresRef.current = Date.now() + expiresInSec * 1000;
		secondsRemainingRef.current = expiresInSec;
	}, [expiresInSec]);

	return new CountdownTimerState(secondsRemaining);
};
